var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 5.6875H4.0625",
    stroke: "#F32E2E",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 10.5625V17.0625",
    stroke: "#F32E2E",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 10.5625V17.0625",
    stroke: "#F32E2E",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 5.6875V21.125C20.3125 21.3405 20.2269 21.5472 20.0745 21.6995C19.9222 21.8519 19.7155 21.9375 19.5 21.9375H6.5C6.28451 21.9375 6.07785 21.8519 5.92548 21.6995C5.7731 21.5472 5.6875 21.3405 5.6875 21.125V5.6875",
    stroke: "#F32E2E",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 5.6875V4.0625C17.0625 3.63152 16.8913 3.2182 16.5865 2.91345C16.2818 2.6087 15.8685 2.4375 15.4375 2.4375H10.5625C10.1315 2.4375 9.7182 2.6087 9.41345 2.91345C9.10871 3.2182 8.9375 3.63152 8.9375 4.0625V5.6875",
    stroke: "#F32E2E",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d3b86d722a52de4819d9b07babfcbb32.svg";
export { ForwardRef as ReactComponent };